<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="mainContentFullWith">
  <mat-tab-group [selectedIndex]="selectedIndex">
    <mat-tab label="Schadenmeldung" disabled class="unselectable">
      <div class="unselectable headerTitle headline">{{translation.ClosedDamageReports}}</div>
      <div class="gridParentContainer">
        <ejs-grid #damageCaseGrid class="responsiveGrids"
                  (rowSelected)="damageCaseRowSelect($event)"
                  [locale]="locale"
                  [dataSource]="damageCaseDataSource"
                  (dataBound)="onDataBound()">
                  <e-columns>
                    <e-column field="Id" [headerText]="this.translation.OrderNumber" textAlign="Left" [isPrimaryKey]="true"></e-column>
                    <e-column field="OriginalSender" [headerText]="this.translation.Sender" textAlign="Left"></e-column>
                    <e-column field="OriginalRecipient" [headerText]="this.translation.Recipient" textAlign="Left"></e-column>
                    <e-column field="OriginalModel" [headerText]="this.translation.Model" textAlign="Left"></e-column>
                    <e-column field="ChassisNo" [headerText]="this.translation.ChassisNumber" textAlign="Left"></e-column>
                    <e-column field="Identification" [headerText]="this.translation.Identification" textAlign="Left"></e-column>
                    <e-column field="License" [headerText]="this.translation.ControlPlate" textAlign="Left"></e-column>
                    <e-column field="ExternalState" [headerText]="this.translation.Status" textAlign="Left">
                      <ng-template #template let-data>{{ data.ExternalState | externalState }}</ng-template>
                    </e-column>
                    <e-column field="FeedState" [headerText]="this.translation.Activity" textAlign="Left" [template]="feedStateTemplate">
                      <ng-template #feedStateTemplate let-data>
                        <i *ngIf="data.FeedState === 1" class="bi bi-chat-dots-fill gridIcon"></i>
                      </ng-template>
                    </e-column>
                  </e-columns>
        </ejs-grid>
      </div>
    </mat-tab>
    <mat-tab label="{{translation.DamageReport}}" disabled class="unselectable">
      <div class="damageCaseContainer">
        <div class="damageCaseInfos">
          <mat-card class="damageCaseCardLeft">
            <mat-card-content class="damageCaseCardContent">
              <mat-card-title class="damageCaseCardTitle">{{translation.OrderInformations}}</mat-card-title>
              <mat-card-subtitle class="addressLine">{{translation.Id}}: {{damageCase.Id}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.Sender}}: {{damageCase.OriginalSender}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.Recipient}}: {{damageCase.OriginalRecipient}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.Status}}: {{damageCase.ExternalState | externalState }}</mat-card-subtitle>
            </mat-card-content>
          </mat-card>
          <mat-card class="damageCaseCardRight">
            <mat-card-content class="damageCaseCardContent">
              <mat-card-title class="damageCaseCardTitle">{{translation.VehicleInformation}}</mat-card-title>
              <mat-card-subtitle class="addressLine">{{translation.Vehicle}}: {{damageCase.OriginalModel}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.ChassisNumber}}: {{damageCase.ChassisNo}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.Mark}}: {{damageCase.License}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.Reference}}: {{damageCase.Identification}}</mat-card-subtitle>
            </mat-card-content>
          </mat-card>
        </div>
        <form id="damageCaseForm" class="row">
          <div class="col-xs-6 col-sm-6 col-md-1 col-lg-1">
            <mat-form-field class="formField">
              <input placeholder="{{translation.DamageDate}}" matInput name="senderDate" [(ngModel)]="damageCase.DamageDate" readonly>
            </mat-form-field>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-1 col-lg-1">
            <mat-form-field class="formField">
              <input placeholder="{{translation.Time}}" matInput name="damageTime" [(ngModel)]="damageCase.DamageTime" readonly>
            </mat-form-field>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
            <mat-form-field class="formField">
              <mat-label>{{translation.CostEstimate}}</mat-label>
              <input matInput name="costEstimate" [(ngModel)]="damageCase.CostEstimate" type="number" class="rightAlign" readonly>
              <span matSuffix style="color: rgba(0, 0, 0, 0.38);">&nbsp;CHF</span>
            </mat-form-field>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
            <mat-form-field class="formField">
              <mat-label>{{translation.Invoice}}</mat-label>
              <input matInput name="invoice" [(ngModel)]="damageCase.DamageAmount" type="number" class="rightAlign" readonly>
              <span matSuffix>&nbsp;CHF</span>
            </mat-form-field>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 buttonContainer"></div>
          <div class="col-12" *ngIf="damageCase.DamageDocuments">
             <mat-card class="damageCard" *ngIf="damageCase.DamageDocuments.length > 0">
              <mat-card-title class="damageCaseCardTitle">{{translation.Documents}}</mat-card-title>
              <mat-card-content>
                <div class="row damageRow" *ngFor="let document of damageCase.DamageDocuments">
                  <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 d-flex align-items-center">
                    <mat-form-field class="w-100">
                      <mat-label>{{translation.DocumentType}}</mat-label>
                      <input matInput readonly [value]="document.DocumentType === '0' ? translation.CostEstimate : translation.Invoice">
                    </mat-form-field>
                  </div>
                  <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 d-flex align-items-center">
                    <mat-form-field class="w-100">
                      <mat-label>{{translation.FileName}}</mat-label>
                      <input matInput readonly [value]="document.FileName">
                    </mat-form-field>
                  </div>
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 imageContainer">
                    <img [src]="IsImage(document.Base64String) ? document.Base64String : './../../../../assets/images/file.svg'" (click)="onPreviewClick(document.Base64, document.FileName)">
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="col-12" *ngIf="damageCase.Damages">
            <mat-card class="damageCard" *ngIf="damageCase.Damages.length > 0">
              <mat-card-title class="damageCaseCardTitle">{{translation.Damages}}</mat-card-title>
              <div class="row damageRow" *ngFor="let damage of damageCase.Damages">
                <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>{{translation.DamageArea}}</mat-label>
                    <input matInput readonly [value]="getDamageAreaDescription(damage.AreaId)">
                  </mat-form-field>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>{{translation.DamageType}}</mat-label>
                    <input matInput readonly [value]="getDamageTypeDescription(damage.TypeId)">
                  </mat-form-field>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 imageContainer">
                  <div *ngFor="let image of damage.Images; let i = index">
                    <img [src]="image.Base64" (click)="onPreviewClick(image.Base64, image.FileName)"/>
                  </div>
                </div>
              </div>
            </mat-card>
          </div>
          <div class="col-12" *ngIf="damageCase.Feeds != null">
            <mat-card class="damageCard">
              <mat-card-title>{{translation.Activity}}</mat-card-title>
              <mat-card-content>
                <div class="feedHistoryContainer d-flex flex-row w-100" *ngIf="damageCase.Feeds.length === 0">
                  <p>{{translation.NoActivitesToThisCase}}</p>
                </div>
                <div class="feedHistoryContainer d-flex flex-row w-100" *ngFor="let feed of damageCase.Feeds">
                  <div class="feedCircleContainer">
                    <div class="feedCircle" [ngClass]="feed.SenderName === 'System' ? 'feedCircleSystem' : feed.ExternalSender ? 'feedCirtleExternal' : 'feedCircleInternal'">{{ feed.SenderName | initials }}</div>
                  </div>
                  <div class="d-flex flex-column w-100 h-100">
                    <div class="feedHeader d-flex flex-column w-100">
                      <div class="w-100"><strong>{{feed.SenderName}}</strong></div>
                      <div><i style="color: gray;">{{feed.TimeStamp | date:'dd.MM.yyyy HH:mm:ss':'de' }}</i></div>
                    </div>
                    <div class="feedContent w-100" [innerHTML]="feed.ContentHtml | safeHtml"></div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 buttonContainer">
            <button type="button" class="whiteText" mat-button (click)="goBack()">{{translation.Back}}</button>
          </div>
        </form>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<app-footer></app-footer>